import { NavigationExtras } from '@angular/router';

import { Link } from '@ecm/router';

import { TrackedPage } from '../tracking/trackedPage.enum';

export class ButtonViewModel {
    public label: string;
    public link?: Link;
    public href?: string;
    public trackingArea: string;
    public trackingName: string;
    public trackedPage?: TrackedPage;
    public trackingLabel?: string;
    public additionalContent?: string;
    public switchBrand = false;
    public navigationExtras: NavigationExtras = null;
    public params: Map<string, string>;
    public hrefLink?: string;

    public constructor(label: string) {
        this.label = label;
    }
}
